import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@customerio/pluma-components/react';

const NewsletterSentPage = lazy(() => import('@/pages/workspaces/broadcasts/newsletter/overview/sent/index.page'));

function NewsletterSentRoute() {
  const { newsletterId } = Route.useParams();
  return (
    <Suspense fallback={<PageLoader label="Loading…" />}>
      <NewsletterSentPage newsletterId={newsletterId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent/',
)({ component: NewsletterSentRoute });
